module.exports = __webpack_public_path__ + "img/service-siteweb.ee44fad.png";